import { ApiClient } from 'ApiClient';
import { Report, UserTimeLogReport, ReportFilter, JobReport } from 'interfaces';
import { Reports } from 'enums';

class ReportService {
  public async getAllReports(): Promise<Report[]> {
    return ApiClient.get<Report[]>('reports');
  }

  public async getUserReport(data: ReportFilter): Promise<UserTimeLogReport[]> {
    return ApiClient.post(`reports/get-data/${Reports.USERS_TIME_LOG}`, data);
  }

  public async getJobReport(data: ReportFilter): Promise<JobReport[]> {
    return ApiClient.post(`reports/get-data/${Reports.JOB_REPORT}`, data);
  }

  /**
   * Any report, by id. Used by GenericReport so a report added to the
   * database needs no frontend change to become usable.
   */
  public async getReportData(
    id: number,
    data: ReportFilter,
  ): Promise<Record<string, any>[]> {
    return ApiClient.post(`reports/get-data/${id}`, data);
  }
}

const singleton = new ReportService();

export { singleton as ReportService };
